import { createFileRoute } from "@tanstack/react-router";
import { PartnerShell } from "../../../features/partner/components/partner-shell";
import { PartnerTripSettingsPage } from "../../../features/partner/pages/partner-trip-settings-page";

/** `/{lang}/partner/trips/{activityId}/settings`: seats, deposit, dates, departure cities. */
export const Route = createFileRoute("/$lang/_partner/partner/trips/$activityId/settings")({
  component: PartnerTripSettingsRoute,
});

function PartnerTripSettingsRoute() {
  const { lang, activityId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <PartnerShell lang={lang} search={search} tab="trips">
      <PartnerTripSettingsPage activityId={activityId} />
    </PartnerShell>
  );
}
